function cssValueWithUnit(value) {
  return typeof value === 'number' ? `${value}px` : value;
}

export { cssValueWithUnit };
//# sourceMappingURL=cssValueWithUnit.mjs.map
